$(document).ready(function () {
  try {
    $('.product__bottom .tab-links a').on('click', function (e) {
      e.preventDefault();
      var $li = $(this).parent();
      var liIndex = $li.index();
      $li.addClass('active').siblings('li').removeClass('active');
      $('.tab-content')
        .find('.tab')
        .eq(liIndex)
        .stop(true, true)
        .slideDown()
        .siblings('.tab')
        .stop(true, true)
        .slideUp();
    });

    $('.tab-content .cta-more a').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $parent = $this.closest('.tab-content');
      $this.toggleClass('active');
      $parent.find('.additional-content').toggleClass('full');
    });
  } catch (e) {
    Rollbar.error('tabs js', e);
  }
});
